// Pieni avain-arvo-tallennus. Selaimessa ja Capacitorin WebView'ssä
// localStorage säilyy sovelluksen sulkemisen yli. Kaikki kutsut on kääritty
// try/catchiin: yksityisessä selausikkunassa tallennus voi puuttua, eikä
// sovellus saa silloin kaatua.

import { queueRecorderMirror } from "./recorderMirror.js";

const PREFIX = "tilehunt:";

export const storage = {
  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(PREFIX + key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch {
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
      if (key === "recorder") queueRecorderMirror(value);
      return true;
    } catch {
      // Yritä varmistaa retki IndexedDB:hen myös silloin, kun esimerkiksi
      // localStorage-kiintiö täyttyi. Recorder näyttää edelleen virheen.
      if (key === "recorder") queueRecorderMirror(value);
      return false;
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      /* ei tehtävää */
    }
  },
};

/** Muistitallennus testeihin. Sama rajapinta kuin yllä. */
export function memoryStorage() {
  const map = new Map();
  return {
    get: (k, fallback = null) => (map.has(k) ? structuredClone(map.get(k)) : fallback),
    set: (k, v) => (map.set(k, structuredClone(v)), true),
    remove: (k) => map.delete(k),
  };
}
